export const FETCH_STAT_RESULTS_REQUEST = "FETCH_STAT_RESULTS_REQUEST";
export const FETCH_STAT_RESULTS_SUCCESS = "FETCH_STAT_RESULTS_SUCCESS";
export const FETCH_STAT_RESULTS_FAILURE = "FETCH_STAT_RESULTS_FAILURE";